export default "__VITE_ASSET__BQ2rHF3x__"